import React from "react";
import { compose, graphql } from "react-apollo";

import { INVENTORY_ENTRIES_QUERY, INVENTORY_ITEMS_QUERY, INVENTORY_QUANTITIES_QUERY } from "views/StockMaterials/stockMaterialsQueries";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import translateErrorMessage from "utils/translateErrorMessage";
import { REGULARIZE_INVENTORY_LOCATION_QUANTITY_MUTATION } from "./stockInputMutations";
import StockRegulateModal from "./StockRegulateModal";

const StockRegulate = ({
  regularizeInventoryLocationQuantity,
  snackbarContext,
  toggleModal,
  isOpen,
}) => {
  const onSubmit = ({ inventoryLocationId, inventoryItemId, quantity }) => {
    regularizeInventoryLocationQuantity({
      variables: { id: inventoryLocationId, inventoryItemId, quantity },
      refetchQueries: [
        { query: INVENTORY_ENTRIES_QUERY },
        { query: INVENTORY_ITEMS_QUERY },
        { query: INVENTORY_QUANTITIES_QUERY },
      ]
    })
      .then(() => {
        snackbarContext.setNotificationTimeOut(Color.success, "Quantiidades regularizadas com sucesso.");
        toggleModal();
      })
      .catch(error => {
        snackbarContext.setNotificationTimeOut(Color.danger, translateErrorMessage(error));
      });
  };
  return (
    <StockRegulateModal
      title="Regularizar quantidades de estoque"
      onSubmit={onSubmit}
      isOpen={isOpen}
      toggleModal={toggleModal}
    />
  );
};

export default compose(
  graphql(REGULARIZE_INVENTORY_LOCATION_QUANTITY_MUTATION, { name: "regularizeInventoryLocationQuantity", }),
  withSnackbarConsumer,
)(StockRegulate);
